import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=4c39c465&scoped=true&"
import script from "./SessionCard.vue?vue&type=script&lang=ts&"
export * from "./SessionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=4c39c465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c39c465",
  null
  
)

export default component.exports